function Avatar({ image }) {
  return (
    <div className="avatar">
      <img src={image} alt="profile" />
    </div>
  );
}

export default Avatar;